module.exports = __webpack_public_path__ + "static/img/ForgotPassword.eef05029.png";